import { DestroyRef, Directive, inject, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '@core/services/api/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[appIsAuthenticated]',
})
export class IsAuthenticatedDirective<T> implements OnInit {

  destroyRef = inject(DestroyRef);

  hasView = false;

  constructor(
    private templateRef: TemplateRef<T>,
    private authService: AuthService,
    private viewContainer: ViewContainerRef,
  ) {}

  ngOnInit() {
    this.authService.isAuthenticated$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isAuthenticated: boolean) => {
        if (isAuthenticated && !this.hasView) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView = true;
        } else if (this.hasView) {
          this.viewContainer.clear();
          this.hasView = false;
        }
      });
  }
}
